import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { StyledEngineProvider } from "@mui/material/styles";
import * as serviceWorkerRegistration from "./utilities/serviceWorkerRegistration";
// import reportWebVitals from "./utilities/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //TODO the StrictMode trigger an issue with reCaptcha and render just once
  // https://github.com/dozoisch/react-google-recaptcha/issues/250
  // <React.StrictMode>
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
